import { Button } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Card, Col, Row } from 'reactstrap';

import { PathsLayouts } from '../../../config/routes';
import { NonStructuredSectionsFiltersFormLoader } from './hooks/NonStructuredSectionsFiltersFormLoader';
import { NonStructuredSectionsLoader } from './hooks/NonStructuredSectionsLoader';
import SectionsSearch from './parts/SectionsSearch';
import SectionsTable from './parts/SectionsTable';

const Sections = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Card className="p-4 mt-2 mx-3">
      <NonStructuredSectionsFiltersFormLoader fetchImmediately>
        <NonStructuredSectionsLoader
          defaultQuery={{ page: 1, items_per_page: 10 }}
          fetchImmediately
        >
          <Row>
            <Col xs={12}>
              <SectionsSearch />
            </Col>
            <Col xs={12} className="mb-4 text-right">
              <Button
                icon="plus"
                onClick={() =>
                  history.push(`${PathsLayouts.nonStructured}/sections/create`)
                }
                outlined
                size="md"
                text={t('sectionsMaintainer.list.createSection')}
              />
            </Col>
            <Col xs={12}>
              <SectionsTable />
            </Col>
          </Row>
        </NonStructuredSectionsLoader>
      </NonStructuredSectionsFiltersFormLoader>
    </Card>
  );
};

export default Sections;
